export default __webpack_public_path__ + "static/media/img_3.6f3efda1.JPG";